// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__7GYAl","deals":"styles_deals__YVwUf","container":"styles_container__mY0ix","phAnimation":"styles_phAnimation__OrMl2"};